import { GetServerSideProps, InferGetServerSidePropsType } from 'next'

import { PAGE_PATH } from '@src/quince-site-common/src/constants/pageData'
import { getSeoMetapageData } from '@src/quince-site-common/src/utils/seo/getSeoMetadata'
import { ServerSideBaseProps } from '@src/server-side/api/api.types'
import { getServerSideBaseProps } from '@src/server-side/get-server-side-props'

import Layout from '../layout'

import SearchPage from './search-page'

export const getServerSideProps = (async ctx => {
  const serverSideBaseProps = await getServerSideBaseProps(ctx, PAGE_PATH.SEARCH)
  if ('props' in serverSideBaseProps) {
    const props = await serverSideBaseProps.props
    return {
      props: {
        ...props,
        seoMetaData: getSeoMetapageData({
          slug: 'search',
          seoTitle: 'Search',
          seoDescription: 'Search items from Quince',
        }),
      },
    }
  }
  return serverSideBaseProps
}) satisfies GetServerSideProps<ServerSideBaseProps>

export default function PageSearch(props: InferGetServerSidePropsType<typeof getServerSideProps>) {
  return (
    <Layout {...props}>
      <SearchPage />
    </Layout>
  )
}
